import styled from 'styled-components';

const ListContainer = styled.div`
  background: white;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`;

type Alert = {
  name: string;
  message: string;
  time: string;
};

type Props = {
  alerts: Alert[];
};

export const AlertList = ({ alerts }: Props) => {
  return (
    <ListContainer>
      <h4>Alert Notice</h4>
      <ul>
        {alerts.map((a, i) => (
          <li key={i}><strong>{a.name}</strong>: {a.message} - {a.time}</li>
        ))}
      </ul>
    </ListContainer>
  );
};
